import styled from 'styled-components';

const accentMap = {
    win: {
        bar: '#34d399',
        glow: 'rgba(52, 211, 153, 0.45)',
        iconBg: 'rgba(52, 211, 153, 0.12)',
        iconColor: '#6ee7b7',
        value: '#6ee7b7',
    },
    loss: {
        bar: '#fb7185',
        glow: 'rgba(251, 113, 133, 0.45)',
        iconBg: 'rgba(251, 113, 133, 0.12)',
        iconColor: '#fda4af',
        value: '#fda4af',
    },
    draw: {
        bar: '#94a3b8',
        glow: 'rgba(148, 163, 184, 0.35)',
        iconBg: 'rgba(148, 163, 184, 0.12)',
        iconColor: '#cbd5e1',
        value: '#e2e8f0',
    },
    resumeProfit: {
        bar: '#22d3ee',
        glow: 'rgba(34, 211, 238, 0.4)',
        iconBg: 'rgba(34, 211, 238, 0.12)',
        iconColor: '#67e8f9',
        value: '#67e8f9',
    },
    resumeLoss: {
        bar: '#fb7185',
        glow: 'rgba(251, 113, 133, 0.45)',
        iconBg: 'rgba(251, 113, 133, 0.12)',
        iconColor: '#fda4af',
        value: '#fda4af',
    },
    resumeNeutral: {
        bar: '#fbbf24',
        glow: 'rgba(251, 191, 36, 0.35)',
        iconBg: 'rgba(251, 191, 36, 0.1)',
        iconColor: '#fcd34d',
        value: '#fcd34d',
    },
};

export const getAccent = (variant) => accentMap[variant] || accentMap.draw;

/** Linha única: ícone | título + descrição | valor (referência “banca”) */
export const InsightRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 18px;
    padding: 22px 24px;
    min-height: 118px;
    box-sizing: border-box;
    border-radius: 16px;
    background: linear-gradient(
        145deg,
        rgba(18, 24, 42, 0.92) 0%,
        rgba(8, 12, 24, 0.88) 50%,
        rgba(0, 0, 0, 0.5) 100%
    );
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.45),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);
    position: relative;
    overflow: visible;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: ${(p) => getAccent(p.$variant).bar};
        box-shadow: 0 0 18px ${(p) => getAccent(p.$variant).glow};
        border-radius: 16px 0 0 16px;
    }
`;

export const InsightIconBox = styled.div`
    width: 58px;
    height: 58px;
    min-width: 58px;
    margin-top: 2px;
    flex-shrink: 0;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(p) => getAccent(p.$variant).iconBg};
    color: ${(p) => getAccent(p.$variant).iconColor};
    box-shadow: 0 0 24px ${(p) => getAccent(p.$variant).glow};
    font-size: 28px;

    svg {
        filter: drop-shadow(0 0 6px currentColor);
    }
`;

export const InsightText = styled.div`
    flex: 1;
    min-width: 0;
    padding-right: 8px;
    overflow: visible;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    hyphens: auto;
`;

export const InsightTitle = styled.div`
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(185, 200, 235, 0.92);
    margin-bottom: 8px;
    line-height: 1.45;
`;

export const InsightDesc = styled.div`
    font-size: 15px;
    line-height: 1.55;
    color: rgba(140, 160, 200, 0.88);
`;

export const InsightValue = styled.div`
    text-align: right;
    font-size: clamp(1.35rem, 2.8vw, 1.85rem);
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    color: ${(p) => (p.$color ? p.$color : '#ffffff')};
    text-shadow: 0 0 24px ${(p) => (p.$glow ? p.$glow : 'transparent')};
    flex-shrink: 0;
    line-height: 1.25;
    align-self: flex-start;
    min-width: 5.5rem;
    padding-top: 2px;
`;

export const InsightBadge = styled.span`
    display: inline-block;
    margin-left: 8px;
    padding: 5px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    vertical-align: middle;
    background: ${(p) => getAccent(p.$variant).iconBg};
    color: ${(p) => getAccent(p.$variant).value};
    border: 1px solid rgba(255, 255, 255, 0.08);
`;

/**
 * Empilha linhas. Preenche a célula do MetricsGrid para igualar altura ao card da mesma linha.
 * Uma única InsightRow estica e centraliza o conteúdo (ex.: Total de operações vs Resultado).
 */
export const InsightStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
    flex: 1 1 auto;
    align-self: stretch;
    justify-content: flex-start;
    min-height: 0;
    height: 100%;
    box-sizing: border-box;

    & > ${InsightRow}:only-child {
        flex: 1 1 auto;
        min-height: 100%;
        height: 100%;
        align-items: center;
        align-self: stretch;

        ${InsightIconBox} {
            margin-top: 0;
        }

        ${InsightValue} {
            align-self: center;
            padding-top: 0;
        }
    }
`;
